import { useMemo } from "react";
import Bowser from "bowser";

const useBrowserInfo = () => {
  const browserInfo = useMemo(() => {
    if (typeof window === "undefined") {
      return null;
    }

    const browser = Bowser.getParser(window.navigator.userAgent);
    const browserDetails = {
      name: browser.getBrowserName(),
      version: browser.getBrowserVersion(),
      os: browser.getOSName(),
      osVersion: browser.parsedResult.os.versionName,
      platform: browser.getPlatformType(),
      userAgent: browser._ua,
    };
    browserDetails.allDetails = {
      Browser: browserDetails.name,
      os: browserDetails.os,
      osVersion: browserDetails.osVersion,
      userAgent: browserDetails.userAgent,
    };
    return browserDetails;
  }, []);

  return browserInfo;
};

export default useBrowserInfo;
